<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>


export default {
	name: 'app',
	components: {
	},
	mounted() {
	}
}
</script>

<style>
#app {
}
</style>
